import { FC } from 'react';
import { Box, Button, Text } from '@doda/io-react/common';
import { DetailButton } from 'components/SearchSideBar/CurrentCondition/DetailButton';
import {
  CONDITION_CHANGE_LINK,
  JOB_SEARCH_LIST_LINK,
} from 'components/SearchSideBar/CurrentCondition/constants';
import { ModalOverlay } from 'components/ModalOverlay';
import { OverwriteConditionModal } from 'components/OrverwriteConditionModal';
import { CurrentConditionModal } from 'components/CurrentConditionModal';
import { useCurrentCondition } from 'components/SearchSideBar/CurrentCondition/hooks/useCurrentCondition';
import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { saveCurrentCondition } from 'logics/saveCurrentCondition';
import { SelectedCurrentConditionType } from 'types/searchCondition';
import { formatString } from '@doda/common/src/utils/stringUtil';
import { LabelText } from 'components/SearchSideBar/CurrentCondition/labelText';
import { createSearchConditionName } from '@doda/common/src/logics/saveCondition/saveCondition';
import { createSaveConditionsRequest } from 'logics/createSaveConditionsRequest';
import { EXTEND_CONDITION_QUERY } from 'components/SearchSideBar/constants';
import style from './index.module.scss';

/**
 * CurrentConditionのProps
 * @param isLogin ログイン状態
 * @param searchConditionLabel 検索条件ラベル
 * @param savedSearchCount 保存した検索条件
 * @param selectedCurrentCondition 現在選択されている検索条件
 * @param currentConditionData 検索条件ラベルデータ
 */
interface Props {
  isLogin: boolean;
  searchConditionLabel: string | undefined;
  savedSearchCount: number;
  selectedCurrentCondition: SelectedCurrentConditionType;
  currentConditionData: SearchConditionLabelResponse;
}

export const CurrentCondition: FC<Props> = ({
  isLogin,
  searchConditionLabel,
  savedSearchCount,
  selectedCurrentCondition,
  currentConditionData,
}) => {
  const {
    detailModal,
    overWriteModal,
    isShowSaveButton,
    onClickSaveButtonJobSearchList,
  } = useCurrentCondition({
    isLogin,
    searchConditionLabel,
    savedSearchCount,
    selectedCurrentCondition,
  });
  const conditionChangeLink = `${CONDITION_CHANGE_LINK.LOGIN_STATE_LINK}?${formatString(JOB_SEARCH_LIST_LINK.CONDITION_CHANGE_USRCLK, [isLogin ? 'login' : 'logout'])}&${EXTEND_CONDITION_QUERY.JOB_SEARCH_LIST}`;

  return (
    <>
      <Box className={style['current-condition__wrapper']}>
        <div className={style['current-condition__heading']}>
          <Text size="16" weight="bold">
            現在の検索条件
          </Text>
          <span>
            [
            <a
              href={conditionChangeLink}
              className={style['current-condition__link']}
            >
              条件変更
            </a>
            ]
          </span>
        </div>
        <LabelText searchConditionLabel={searchConditionLabel} />
        {isShowSaveButton && (
          <>
            <DetailButton onClick={detailModal.onOpen} />
            <Button
              variant="outline_gray"
              widthPercentage={100}
              onClick={onClickSaveButtonJobSearchList}
            >
              検索条件を保存
            </Button>
          </>
        )}
      </Box>
      <ModalOverlay
        show={overWriteModal.isOpen}
        onClickOverlay={overWriteModal.onClose}
      >
        <OverwriteConditionModal
          onClickClose={overWriteModal.onClose}
          conditions={createSaveConditionsRequest(selectedCurrentCondition)}
        />
      </ModalOverlay>
      <ModalOverlay
        show={detailModal.isOpen}
        onClickOverlay={detailModal.onClose}
      >
        <CurrentConditionModal
          defaultConditionName={createSearchConditionName()}
          currentConditionData={currentConditionData}
          onClickClose={detailModal.onClose}
          onClickSave={(conditionName) => {
            saveCurrentCondition({
              conditions: createSaveConditionsRequest(selectedCurrentCondition),
              isLogin,
              conditionName,
              savedSearchCount,
            });
          }}
        />
      </ModalOverlay>
    </>
  );
};
